import React, { useState, useEffect } from 'react';
import AdminLayout from './AdminLayout';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
function adminHeaders(json = false) {
  const h = { Authorization: `Bearer ${localStorage.getItem('hrv_admin_token')}` };
  if (json) h['Content-Type'] = 'application/json';
  return h;
}

export default function AdminAliases() {
  const [aliases, setAliases] = useState([]);
  const [search, setSearch]   = useState('');
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [newAlias, setNewAlias]     = useState('');
  const [newCanon, setNewCanon]     = useState('');
  const [addErr, setAddErr]         = useState('');
  const [addSaving, setAddSaving]   = useState(false);
  const [deleteId, setDeleteId]     = useState(null);

  const fetchAliases = async () => {
    try {
      const res = await fetch(`${API_URL}/admin/aliases`, { headers: adminHeaders() });
      const d = await res.json();
      setAliases(d.aliases || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAliases(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    setAddErr('');
    if (!newAlias.trim() || !newCanon.trim()) { setAddErr('Both fields are required'); return; }
    setAddSaving(true);
    try {
      const res = await fetch(`${API_URL}/admin/aliases`, {
        method: 'POST', headers: adminHeaders(true),
        body: JSON.stringify({ alias: newAlias.trim(), canonical_name: newCanon.trim() }),
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error || 'Failed');
      setNewAlias(''); setNewCanon('');
      setShowAdd(false);
      await fetchAliases();
    } catch (e) {
      setAddErr(e.message);
    } finally {
      setAddSaving(false);
    }
  };

  const handleDelete = async (id) => {
    setDeleteId(id);
    try {
      await fetch(`${API_URL}/admin/aliases/${id}`, { method: 'DELETE', headers: adminHeaders() });
      await fetchAliases();
    } finally {
      setDeleteId(null);
    }
  };

  const filtered = aliases.filter(a =>
    !search || a.alias.toLowerCase().includes(search.toLowerCase()) ||
    a.canonical_name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <AdminLayout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '28px' }}>
        <div>
          <h1 style={{ fontSize: '1.6rem', fontWeight: '700', color: '#1a202c', margin: 0 }}>Test Name Aliases</h1>
          <p style={{ color: '#718096', margin: '6px 0 0' }}>Map non-standard test names to canonical names for trend tracking</p>
        </div>
        <button onClick={() => { setShowAdd(true); setAddErr(''); }} style={{
          padding: '10px 20px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '8px',
          fontWeight: '600', cursor: 'pointer', fontSize: '0.9rem',
        }}>
          + Add Alias
        </button>
      </div>

      {/* Add modal */}
      {showAdd && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '32px', width: '480px', maxWidth: '95vw', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <h3 style={{ margin: '0 0 20px', fontSize: '1.15rem', fontWeight: '700', color: '#1a202c' }}>Add Test Name Alias</h3>
            {addErr && (
              <div style={{ background: '#fff5f5', border: '1px solid #fed7d7', color: '#c53030', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '0.875rem' }}>
                {addErr}
              </div>
            )}
            <form onSubmit={handleAdd}>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '600', color: '#4a5568', marginBottom: '6px' }}>Alias (as it appears in reports)</label>
                <input value={newAlias} onChange={e => setNewAlias(e.target.value)} placeholder="e.g. HbA1c, A1C, Haemoglobin A1c"
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '0.875rem', boxSizing: 'border-box' }} />
              </div>
              <div style={{ marginBottom: '24px' }}>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '600', color: '#4a5568', marginBottom: '6px' }}>Canonical Name (standardized name)</label>
                <input value={newCanon} onChange={e => setNewCanon(e.target.value)} placeholder="e.g. HbA1c"
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '0.875rem', boxSizing: 'border-box' }} />
              </div>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button type="button" onClick={() => setShowAdd(false)} style={{ padding: '10px 20px', background: '#f7fafc', border: '1px solid #e2e8f0', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', color: '#4a5568' }}>
                  Cancel
                </button>
                <button type="submit" disabled={addSaving} style={{ padding: '10px 20px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }}>
                  {addSaving ? 'Saving…' : 'Add Alias'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Search */}
      <div style={{ marginBottom: '16px' }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search aliases or canonical names…"
          style={{ width: '320px', padding: '10px 14px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '0.875rem', background: 'white' }} />
      </div>

      {/* Info banner */}
      <div style={{ background: '#ebf4ff', border: '1px solid #bee3f8', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', color: '#2b6cb0', fontSize: '0.8rem' }}>
        ℹ️ Aliases are hot-loaded into the interpretation engine. New aliases take effect immediately without server restart.
        Currently <strong>{aliases.length}</strong> custom alias{aliases.length !== 1 ? 'es' : ''} defined.
      </div>

      {/* Table */}
      <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f7fafc', borderBottom: '1px solid #e2e8f0' }}>
              {['Alias (Raw Name)', 'Canonical Name', 'Added By', 'Date Added', ''].map(h => (
                <th key={h} style={{ padding: '11px 16px', textAlign: 'left', fontSize: '0.75rem', fontWeight: '700', color: '#718096', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ padding: '40px', textAlign: 'center', color: '#a0aec0' }}>Loading…</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={5} style={{ padding: '40px', textAlign: 'center', color: '#a0aec0' }}>
                {search ? 'No aliases match your search' : 'No custom aliases defined yet. Add one to get started.'}
              </td></tr>
            ) : filtered.map((a, i) => (
              <tr key={a.id} style={{ borderBottom: '1px solid #f0f4f8', background: i % 2 === 0 ? 'white' : '#fafafa' }}>
                <td style={{ padding: '12px 16px', color: '#2d3748', fontFamily: 'monospace', fontSize: '0.875rem', fontWeight: '600' }}>{a.alias}</td>
                <td style={{ padding: '12px 16px' }}>
                  <span style={{ padding: '3px 10px', background: '#ebf4ff', color: '#2b6cb0', borderRadius: '20px', fontSize: '0.8rem', fontWeight: '600' }}>
                    {a.canonical_name}
                  </span>
                </td>
                <td style={{ padding: '12px 16px', color: '#718096', fontSize: '0.8rem' }}>{a.created_by || '—'}</td>
                <td style={{ padding: '12px 16px', color: '#718096', fontSize: '0.8rem' }}>
                  {a.created_at ? new Date(a.created_at).toLocaleDateString() : '—'}
                </td>
                <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                  <button onClick={() => handleDelete(a.id)} disabled={deleteId === a.id}
                    style={{ padding: '5px 12px', background: '#fff5f5', color: '#c53030', border: '1px solid #fed7d7', borderRadius: '6px', fontSize: '0.78rem', fontWeight: '600', cursor: 'pointer' }}>
                    {deleteId === a.id ? '…' : 'Delete'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
